import { useState } from 'react';

import { messageOf } from './adjustment.catalog.constants';
import { applyPlan, revertPlan } from './adjustment.action.builders';

export default function useAdjustmentActions(context) {

    const { onClose, onApplied, setAlert } = context;

    const [isSaving, setIsSaving] = useState(false);
    const [actionError, setActionError] = useState(null);

    const run = (plan) => {
        setIsSaving(true);
        setActionError(null);

        return plan.call()
            .then(() => {
                setAlert(plan.success, 'success');
                if (plan.shouldRefresh) onApplied();
                onClose();
            })
            .catch((requestError) => setActionError(messageOf(requestError, plan.fallback)))
            .finally(() => setIsSaving(false));
    }

    return {
        isSaving,
        actionError,
        apply: (selection, submission) => run(applyPlan(context, selection, submission)),
        revert: (adjustment) => run(revertPlan(context, adjustment))
    };
}
